import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(private translate: TranslateService) { }
  calculateDisabledDates(minDate: Date, maxDate: Date, dates: Date[]): Date[] {
    let disabledDates: Date[] = [];
    let startDate = new Date(minDate);
    while (startDate < maxDate) {
      let found = dates.find((el) => {
        return el.toISOString() == startDate.toISOString();
      });

      if (!found) {
        disabledDates.push(new Date(startDate));
      }
      startDate.setDate(startDate.getDate() + 1);
    }
    return disabledDates;
  }
  parseDateToLocal(dateString: string): Date {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // Month is zero-based
  }
  dateToSummaryString(dateString: string): string {
    let date: Date = new Date(dateString);
    return this.translate.instant(`days.${date.getDay().toString()}`);
  }
}
